import { render, staticRenderFns } from "./UploadBiometria.vue?vue&type=template&id=63fc4717&scoped=true"
import script from "./UploadBiometria.vue?vue&type=script&lang=js"
export * from "./UploadBiometria.vue?vue&type=script&lang=js"
import style0 from "./UploadBiometria.vue?vue&type=style&index=0&id=63fc4717&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fc4717",
  null
  
)

export default component.exports